import { ILayerDefinition } from '@esri/arcgis-rest-feature-service';
import { CalciteList, CalciteListItem } from '@esri/calcite-components-react';
import React, { useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';

export type RecentPanelProps = {
  url: string;
  layerDefinition: ILayerDefinition | undefined | null;
  onLayerClick: (url: string) => void;
};

export const RecentPanel: React.FC<RecentPanelProps> = ({
  url,
  onLayerClick,
  layerDefinition,
}) => {
  const [recentLayers, setRecentLayers] = useLocalStorage<
    { name: string; url: string }[]
  >('recent-layers', []);

  useEffect(() => {
    const layerName = layerDefinition?.name;
    if (url && layerName) {
      setRecentLayers((prevLayers) => {
        const newRecentLayers = prevLayers.filter((layer) => layer.url !== url);

        return [{ url, name: layerName }, ...newRecentLayers];
      });
    }
  }, [layerDefinition, setRecentLayers, url]);

  return (
    <CalciteList>
      {recentLayers.map((layer) => (
        <CalciteListItem
          key={layer.url}
          label={layer.name}
          description={layer.url}
          onCalciteListItemSelect={() => {
            onLayerClick(layer.url);
          }}
        />
      ))}
    </CalciteList>
  );
};
